import { makeObservable, observable } from 'mobx';

class ShopObject {
  loaded = false;
  userId = null;

  constructor(data) {
    makeObservable(this, {
      loaded: observable,
    });
    Object.assign(this, data);
    if (data.user) {
      this.userId = data.user.id;
    }
  }
}

export default ShopObject;
